// @ts-nocheck
import * as broker from './broker';

export default function(go) {
    function Label(options, key) {
        this.setValues(options);

        // Label text container
        const span = this.span_ = document.createElement('span');
        span.className = getClusterClass(this.text);

        // Label box
        const div = this.div_ = document.createElement('div');
        div.appendChild(span);
        div.className = `countinfo_${key}`;
        div.style.cssText = 'position: absolute; display: none;';

        this.key = key;
    }

    Label.prototype = new go.maps.OverlayView();

    Label.prototype.onAdd = function() {
        const pane = this.getPanes().overlayMouseTarget;

        broker.subscribe(
            `mapLabel_${this.key}`,
            'CHANGEDLABELVISIBILITY',
            () => { this.draw(); }
        );

        pane.appendChild(this.div_);
    };

    Label.prototype.draw = function() {
        const projection = this.getProjection();
        const position = projection.fromLatLngToDivPixel(this.get('position'));

        const div = this.div_;
        div.style.left = `${position.x}px`;
        div.style.top = `${position.y}px`;
        div.style.zIndex = -50;

        const visible = this.get('visible');
        div.style.display = visible ? 'block' : 'none';

        this.span_.innerHTML = this.get('text').toString();

        const clickHandler = this.clickHandler;
        google.maps.event.addDomListener(div, 'click', clickHandler);
    };

    return Label;
}

function getClusterClass(num) {
    switch (true) {
        case num >= 10000:
            return 'clustersize5';
        case num >= 1000:
            return 'clustersize4';
        case num >= 100:
            return 'clustersize3';
        case num >= 10:
            return 'clustersize2';
        case num >= 2:
            return 'clustersize1';
        default:
            return 'hotel-map-pin-static';
    }
}
